import { ColumnActionsMode } from '@fluentui/react';

export const oosReconTireDetailsCols = [
  {
    key: 'column1',
    name: 'Prefix',
    fieldName: 'prefix',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column2',
    name: 'Brand #',
    fieldName: 'brandNo',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column3',
    name: 'Suffix',
    fieldName: 'suffix',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column4',
    name: 'Tire Size',
    fieldName: 'tireSize',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column5',
    name: 'Insp Code',
    fieldName: 'inspectionCode',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column6',
    name: 'Dispo Code',
    fieldName: 'dispCode',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column7',
    name: 'No Match',
    fieldName: 'noMatch',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column8',
    name: 'Status',
    fieldName: 'status',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column9',
    name: 'GLS Veh #',
    fieldName: 'vehicleNo',
    isSorted: true,
    isSortedDescending: false,
  },
  {
    key: 'column10',
    name: 'GLS Whl Pos',
    fieldName: 'glsWhlPos',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column11',
    name: 'Date of Last Change',
    fieldName: 'dateModified',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column12',
    name: 'Prev Veh #',
    fieldName: 'prevVehicleNo',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column13',
    name: 'Prev Whl Pos',
    fieldName: 'prevWheelPos',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column14',
    name: 'Survey TD',
    fieldName: 'treadDepth',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column15',
    name: 'Billable TD',
    fieldName: 'billableTreadDepth',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column16',
    name: 'Miles',
    fieldName: 'totMiles',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column17',
    name: 'Comments',
    fieldName: 'comments',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column18',
    name: 'Images',
    fieldName: 'images',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column19',
    name: 'Last Modified By',
    fieldName: 'lastModifiedBy',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
];